// This icon file is generated automatically.
var PBackwardOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 10 10", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M4.59.9L.09 4.78a.3.3 0 000 .44L4.6 9.1c.16.14.41 0 .41-.22V1.12C5 .9 4.75.76 4.59.9zm5 0l-4.5 3.88A.3.3 0 005 5c0 .08.03.16.1.22L9.59 9.1c.16.14.41.01.41-.22V1.12C10 .9 9.75.76 9.59.9z", "fill-rule": "nonzero" } }] }, "name": "p-backward", "theme": "outlined" };
export default PBackwardOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PBackwardOutlined.js
// module id = 3226
// module chunks = 0